import type {
    ImageStyle,
    ViewStyle
} from "react-native";
import type {
    ImageDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import stylesheet from "../../stylesheet";

export const useStyles = ({
    shapeConfigs,
    currentSize,
    radiuses,
    colors,
    spaces
}: ImageDynamicStyleType) => {
    const styles = {
        image: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ImageStyle>,
        figure: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(currentSize) {
        styles.image.height = currentSize.height;

        styles.image.width = currentSize.width;
    } else {
        Object.assign(styles.image, stylesheet.imagePending);
    }

    return styles;
};
